if (!customElements.get('scene-directory')) {
  customElements.define('scene-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const cards = [...this.querySelectorAll('.sd-card')];
      const buttons = [...this.querySelectorAll('[data-filter]')];
      const search = this.querySelector('input[type="search"]');
      const select = this.querySelector('select');
      const count = this.querySelector('[role="status"]');
      const empty = this.querySelector('.sd-empty');
      const requestedCategory = new URLSearchParams(window.location.search).get('category');
      let category = buttons.some(button => button.dataset.filter === requestedCategory)
        ? requestedCategory
        : 'all';
      const update = () => {
        const query = search.value.trim().toLowerCase();
        let total = 0;
        cards.forEach(card => {
          const show = (category === 'all' || card.dataset.category === category) && card.dataset.search.includes(query);
          card.hidden = !show;
          if (show) total++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        select.value = category;
        count.textContent = category === 'all' && !query ? `Showing all ${total} scenes` : `${total} scene${total === 1 ? '' : 's'} found`;
        empty.hidden = total > 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; update(); }, options));
      select.addEventListener('change', () => { category = select.value; update(); }, options);
      search.addEventListener('input', update, options);
      empty.querySelector('button').addEventListener('click', () => { category = 'all'; search.value = ''; update(); search.focus(); }, options);
      this.addEventListener('shopify:block:select', () => { category = 'all'; search.value = ''; update(); }, options);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}
